export default __webpack_public_path__ + "static/media/youtube.d210bb87.svg";